import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 关闭订单
export default async function orderClose(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/close', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
